import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';
import { useAuth } from 'hooks';
import { config } from 'config';
import { EmailTriggerSidebar } from './EmailTriggerSidebar';

export const EmailTriggerButton = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { user } = useAuth();

  // Only show on dev/stg environments and for administrators
  if (config.isProd() || !user?.isAdministrator) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 9999,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => setIsSidebarOpen(true)}
          sx={{
            borderRadius: '50%',
            minWidth: 56,
            width: 56,
            height: 56,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            },
          }}
        >
          <EmailIcon />
        </Button>
      </Box>

      <EmailTriggerSidebar open={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
    </>
  );
};
